import { Action, ActionReducerMap } from '@ngrx/store';

import * as fromProjectEntityList from './project-entity-list/project-entity-list.reducer';
import { ProjectListState } from './project-list.state';

export const projectListReducer: ActionReducerMap<ProjectListState, Action> = {
  projectEntityListState: fromProjectEntityList.reducer
};
